export const updateAnonymousComplaint = (payload?: any) => ({
    type: "@saga/UPDATE_ANONYMOUS_COMPLAINT",
    payload
});

